import { Box, Typography } from "@mui/material"
import { DialogComponent } from "../../../../../components/DialogComponent"
import { useTranslation } from "react-i18next";

export interface IDisableUserAndGroupModal {
    isopen: boolean;
    handleOpenDialog: (set: boolean) => void;
    handleClickConfirm: () => void;
    isUser: boolean;
    groupName?: string;
}

export const DisableUserAndGroupModal: React.FC<IDisableUserAndGroupModal> = ({ handleClickConfirm, handleOpenDialog, isopen, isUser, groupName }) => {
    const { t } = useTranslation();

    return (
        <DialogComponent
            isOpen={isopen}
            onClickCancel={handleOpenDialog}
            onClickConfirm={handleClickConfirm}
            titleContent={isUser ? t("AdminConsole.DisableModalTitle") : t("AdminConsole.DisableGroupModalTitle")}
            isOtpDialog={false}
            isCancelButtonNeeded={true}
            isDisableDialog
            isDeleteGroupDialog={!isUser}
        >
            <Typography
                component="label"
                sx={{
                    textAlign: "center",
                    font: "normal normal 300 16px/24px Segoe UI",
                    letterSpacing: "0px",
                    color: "#2D2D2D",
                    opacity: 1,
                    display: 'flex',
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                {isUser
                    ? t("AdminConsole.ConfirmIfYouReallyWantToDisableSelectedUser")
                    : (
                        <Box>
                            <Typography>
                                {t("AdminConsole.DialogDeleteGroupStart")}
                                <Typography component="span" fontWeight="bold" sx={{ marginX: 1 }}>
                                    "{groupName}".
                                </Typography>
                                {t("AdminConsole.DialogDeleteGroupEnd")}
                            </Typography>
                        </Box>
                    )
                }
            </Typography>
        </DialogComponent>   
    )
}